import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

interface IWarningMessageComponentProps {
    message: string;
};

const WarningMessageComponent = (props: IWarningMessageComponentProps) => {
    return (
        (props.message !== '') ? (
            <MessageBar 
                messageBarType={MessageBarType.warning}
                styles={{
                    root: {
                        marginTop: '10px',
                        marginBottom: '10px',
                    },
                }}>
                {props.message}
            </MessageBar>
        ) : (
             null
        )
    );
};

export default WarningMessageComponent;
